import React from 'react'
import PropTypes from 'prop-types'

import style from './style.css'

export default class InterpolatorView extends React.Component {

  onClick = ( evt ) => {
    evt.stopPropagation()

    const { kf1, timeline, timeCalc } = this.props
    // const x = evt.target.offsetLeft + evt.nativeEvent.offsetX
    const x = timeCalc.discreteX( timeCalc.xFromEvent( evt ) ) 

    if ( this.props.onInterpolatorClicked ) {
      this.props.onInterpolatorClicked( { x, keyframe : kf1, timeline, event : evt } )
    }
  }

  render() {
    const { kf1, kf2, timeline, timeCalc } = this.props
    const v1 = timeCalc.timeToX( kf1.time )
    const v2 = timeCalc.timeToX( kf2.time )
    const w = Math.max( 0, v2 - v1 )

    return (
      <div className={style.interpolatorView} 
        style={{ left : v1, width : w }}
        onClick={this.onClick}>
        <div className={style.interpolatorViewAppearance} />
      </div>
    )
  }

}
